export default 'no-longer-support-your-browser';
